export default __webpack_public_path__ + "images/flags/uz.png";